<template>
  <div>
    <v-card class="mb-5">
      <v-card-title>
        <h1>Garantibelopp</h1>
      </v-card-title> 
      <v-card-text>
        <v-row class="search-form">
          <v-col cols="2">
            <v-text-field
              id="search"
              v-model="searchQuery"
              label="Sök Kundnummer"
              append-icon="search"
              type="text"
              outlined
              dense
              clearable
              placeholder="Sök Kundnummer"
              @keyup.enter="fetchGuarantees(searchQuery)"
              @click:append="fetchGuarantees(searchQuery)"
            />
          </v-col>
          <!--Total display-->
          <v-col class="d-flex justify-end w-33">
            <v-card
              v-if="totals !== null && totals.length > 0"
              class="d-flex justify-left"
            >
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>Tidning</th>
                    <th>Status</th>
                    <th class="text-center">
                      Summa
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(total, pIndex) in totals" :key="pIndex">
                    <td>{{ total.paper }}</td>
                    <td>{{ total.status }}</td>
                    <td class="text-right">
                      {{ total.totalAmount | toCurrency }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
     
      

        <!--Search result-->
   
        <v-card v-for="(guarantee, index) in guarantees" :key="index" class="mx-auto mt-3 elevation-3" variant="outlined">
          <v-card-title class="text-h5">
            Sökresultat för kundnummer: {{ guarantee.customerNr }}
          </v-card-title>

          <v-card-text>
            <GuaranteeCustomerInfo class="text-h6 pb-2"
                                   :customer="guarantee.guaranteeCustomer"
                                   :customer-nr="guarantee.customerNr"
                                   :editable-bankgiro="false"
                                   :address-cols="3"
                                   :bank-cols="3"
                                   :email-cols="4"
                                   :show-receipt="guarantee.invoices.length > 0 || guarantee.paperGuaranteeAmount.length > 0"
                                   @get-reciept="getReciept(guarantee,index,false)"          
            />
            <v-simple-table dense>
              <thead>
                <tr>
                  <th>Belopp</th>
                  <th>Tidning</th>
                  <th>Återbetald</th>
                  <th>Datum</th>
                  <th>Betala ut</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(paper, pIndex) in guarantee.paperGuaranteeAmount" :key="pIndex">
                  <td>{{ paper.amount | toCurrency }}</td>
                  <td>{{ paper.ledger | ledgerToString }}</td>
                  <td>{{ paper.refunded ? "Ja" : "Nej" }}</td>
                  <td>{{ paper.refundedDate | toLocalDate }}</td>
                  <td v-if="!paper.refunded" class="justify-end">
                    <v-btn
                      color="green"
                      x-small
                      elevation="2"
                      outlined
                      @click="addToRefund(guarantee, paper)"
                    >
                      <v-icon>mdi-check</v-icon>
                      Återbetala
                    </v-btn>
                    <v-btn
                      name="Invoice"
                      class="ml-2"
                      color="green"
                      x-small
                      elevation="2"
                      outlined
                      @click="openInvoiceDialog(paper, guarantee)"
                    >
                      <v-icon>mdi-check</v-icon>
                      Delutnyttjande
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <span v-if="guarantee.invoices !== undefined && guarantee.invoices.length > 0" class="bold">Fakturor</span>              
            <v-simple-table v-if="guarantee.invoices !== undefined && guarantee.invoices.length > 0" dense>
              <thead>
                <tr>
                  <th>Belopp</th>                    
                  <th>Tidning</th>                    
                  <th>Faktura</th>
                  <th>OCR</th>
                  <th>Datum</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(invoice, pIndex) in guarantee.invoices" :key="pIndex">
                  <td>{{ invoice.amount | toCurrency }}</td>                    
                  <td>{{ invoice.ledger | ledgerToString }}</td>
                  <td>{{ invoice.invoiceNumber }}</td>                    
                  <td>{{ invoice.ocr }}</td>
                  <td>{{ invoice.usedDateTime | toLocalDate }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-card-text>   
    </v-card>
    <v-card class="elevation-2">
      <v-card-actions v-if="hasRefundedGuarantees" class="justify-end">
        <v-btn x-small elevation="2" @click="send()">
          <!-- <v-icon>mdi-check</v-icon> -->
          Utbetalningsfiler
        </v-btn>
        <v-btn x-small elevation="2" @click="getAllReciepts()">
          <!-- <v-icon>mdi-check</v-icon> -->
          Alla Underlag
        </v-btn>
        <v-btn x-small elevation="2" @click="completeQuestion()">
          <!-- <v-icon>mdi-check</v-icon> -->
          Klarmarkera
        </v-btn>
      </v-card-actions>
      <v-card-title class="text-h5">
        Tillagda Utbetalningar
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-card
            v-for="(guarantee, index) in refundedGuarantees"
            :key="guarantee.customerNr"
            class="mb-4"
          >
            <v-card-title>
              <GuaranteeCustomerInfo
                ref="guaranteeCustomerInfoRefs"
                :key="`guarantee-customer-info-${index}`"
                :ref-in-for="true"
                :customer="guarantee.guaranteeCustomer"
                :customer-nr="guarantee.customerNr"
                :editable-bankgiro="true"
                :editable-orgnumber="true"
                :address-cols="3"
                :bank-cols="3"
                :email-cols="4"
                :show-receipt="true"
                :rules="[rules.required]"
                @update-bankgiro="updateBankgiro"
                @update-orgnummer="updateOrgnumber"
                @update-bankaccount="updateBankaccount"
                @get-reciept="getReciept(guarantee,index,true)"
              />
            </v-card-title>
            <v-card-text>
              <span class="bold">Utbetalningar att skicka</span>              
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>Belopp</th>
                    <th>Tidning</th>
                    <th>Återbetala</th>
                    <th>Datum</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(paper, pIndex) in guarantee.paperGuaranteeAmount"
                    :key="pIndex"
                  >
                    <td>{{ paper.amount | toCurrency }}</td>
                    <td>{{ paper.ledger | ledgerToString }}</td>
                    <td>{{ paper.refunded ? "Tillagd" : "" }}</td>
                    <td v-if="paper.refunded">
                      <v-menu
                        v-model="paper.dateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        dense
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="paper.refundedDate"
                            label=""
                            readonly
                            v-bind="attrs"
                            dense
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="paper.refundedDate"
                          locale="sv-se"
                          :first-day-of-week="1"
                          @input="saveRefund(guarantee)"
                        />
                      </v-menu>
                    </td>
                    <td v-else />
                  </tr>
                </tbody>
              </v-simple-table>

              <span v-if="guarantee.invoices !== undefined && guarantee.invoices.length > 0" class="bold">Fakturor</span>              
              <v-simple-table v-if="guarantee.invoices !== undefined && guarantee.invoices.length > 0" dense>
                <thead>
                  <tr>
                    <th>Belopp</th>                    
                    <th>Tidning</th>                    
                    <th>Faktura</th>
                    <th>OCR</th>
                    <th>Datum</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(invoice, pIndex) in guarantee.invoices" :key="pIndex">
                    <td>{{ invoice.amount | toCurrency }}</td>                    
                    <td>{{ invoice.ledger | ledgerToString }}</td>
                    <td>{{ invoice.invoiceNumber }}</td>                    
                    <td>{{ invoice.ocr }}</td>
                    <td>{{ invoice.usedDateTime | toLocalDate }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogComplete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">
          Är du säker att du vill klarmarkera?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="closeComplete">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click="completedConfirm">
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogInvoice" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">
          Lägg till faktura för {{ invoiceData.ledger | ledgerToString }}
        </v-card-title>
        <v-card-text>
          <v-form ref="invoiceForm">
            <v-text-field
              v-model="invoiceData.invoiceNumber"
              label="Fakturanummer"
              :rules="[rules.required]"
              dense
            />
            <v-text-field
              v-model="invoiceData.amount"
              label="Belopp att dra av"
              type="number"
              :rules="[
                rules.required,
                (val) =>
                  val <= (selectedPaper !== null ? selectedPaper.amount : 0) ||
                  'Kan inte överstiga garantibeloppet',
              ]"
              dense
            />
            <v-text-field
              v-model="invoiceData.ocr"
              label="OCR"
              :rules="[rules.required]"
              dense
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="closeInvoice">
            Avbryt
          </v-btn>
          <v-btn color="blue darken-1" text @click="submitInvoice">
            Spara
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import adminapi from '../../backend/adminapi'
import log from '@/logger'
import GuaranteeCustomerInfo from '@/components/admin/GuaranteeCustomerInfo.vue'
import { forEach, clone } from 'lodash'

export default {
  name: 'Guarantees',
  components: { GuaranteeCustomerInfo },
  data() {
    return {
      dialogComplete: false,
      guarantees: null,
      searchQuery: '', // Add searchQuery to track the input
      loading: true,
      error: null,
      refundedGuarantees: [],
      totals: [],
      dialogInvoice: false,
      selectedPaper: null,
      invoiceData: {
        invoiceNumber: '',
        amount: null,
        ocr: '',
      },
      rules: {
        required: (value) => !!value || 'Obligatorisk.',
        counter: (value) => value.length <= 20 || 'Max 12 tecken',
      },
    }
  },
  computed: {
    // filteredGuarantees() {
    //   // Filter guarantees based on the search query
    //   let tempGuarantees = []
    //   if (this.searchQuery !== '' || this.searchQuery !== null) {
    //     tempGuarantees = this.guarantees.filter(
    //       (guarantee) => guarantee.customerNr == this.searchQuery
    //     )
    //   }

    //   return tempGuarantees
    // },
    hasRefundedGuarantees() {
      // Check if there are any refunded guarantees
      return this.refundedGuarantees.length > 0
    },
  },
  watch: {
    searchQuery(newValue) {
      if (!newValue) {
        this.clearSearch()
      }
    },
    error(newValue) {
      if (newValue) {
        this.$toast.error(newValue)
        this.error = null
      }
    },
  },
  created() {
    // Load stored refunds from backend
    this.loadData()
    // Optionally: this.fetchGuarantees() if you want to load guarantees on page load
  },
  methods: {
    loadData(){
       adminapi
      .adminGetSavedRefunds()
      .then((resp) => {
        log.debug('Loaded saved refunds:', resp.data)
        this.refundedGuarantees = (resp.data || []).map((item) => ({
          ...item,
          dateMenu: false,
          paperGuaranteeAmount: (item.paperGuaranteeAmount || []).map((paper) => ({
            ...paper,
            refundedDate: paper.refundedDate
              ? new Date(paper.refundedDate)
                  .toLocaleDateString('sv-SE')
                  .slice(0, 10)
              : '',
            dateMenu: false,
          })),
        }))
        console.log('Refunded Guarantees:', this.refundedGuarantees)
      })
      .catch((error) => {
        log.debug('Error loading saved refunds:', error)
        this.error = 'Misslyckades med att ladda sparade utbetalningar.'
      })

    adminapi
      .adminGetGuaranteeTotals()
      .then((resp) => {
        log.debug('Guarantee totals:', resp.data.result)
        this.totals = resp.data.result
      })
      .catch((error) => {
        log.debug('Error - Getting guarantee totals:', error)
        this.error =
          'Misslyckades med att hämta totalsummor för garantibelopp.'
      })
    },
    closeComplete() {
      this.dialogComplete = false
    },
    async fetchGuarantees(customerNumber) {
      adminapi
        .adminGetGuaranteesByCustomerNumber(customerNumber)
        .then((resp) => {
          log.debug('Guarantees:' + resp.data)
          this.guarantees = resp.data
          if (this.guarantees.length === 0) {
            this.error = 'Inga garantier hittades.'
          } else {
            this.error = null
          }
        })
        .catch((error) => {
          log.debug('Error - Getting extra invoices:', error)
          this.error = 'Kunde inte hämta garantibelopp för kund.'
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearSearch() {
      this.searchQuery = '' // Clear the search query
      this.guarantees = [] // Clear the guarantees array
    },
    addToRefund(guarantee, paper) {
      paper.refunded = true
      paper.refundedDate = this.getNextMonday()
      let refund = this.refundedGuarantees.find(
        (refund) => refund.customerNr == guarantee.customerNr
      )
      if (refund !== undefined) {
        refund.paperGuaranteeAmount.push(paper)
      } else {
        refund = {
          guaranteeCustomer: clone(guarantee.guaranteeCustomer),
          customerNr: guarantee.customerNr,
          paperGuaranteeAmount: [],
        }
        refund.guaranteeCustomer.bankgiro = ''
        refund.guaranteeCustomer.bankaccount = ''
        refund.paperGuaranteeAmount.push(paper)
      }
      const index = guarantee.paperGuaranteeAmount.indexOf(paper)
      if (index > -1) {
        guarantee.paperGuaranteeAmount.splice(index, 1)
      }

      log.debug('Added to refund:', refund)

      this.saveRefund(refund)
        .then(() => {
          log.debug('Refunds saved:', refund)
          if (!this.refundedGuarantees.includes(refund)) {
            this.refundedGuarantees.unshift(refund)
          }
          if (this.$toast) this.$toast.success('Utbetalning sparad!')
          this.fetchGuarantees(this.searchQuery)
          this.loadData()
        })
        .catch(() => {
          paper.refunded = false
          if (!guarantee.paperGuaranteeAmount.includes(paper)) {
            guarantee.paperGuaranteeAmount.push(paper)
          }
        })
    },
    getNextMonday() {
      const today = new Date()
      const day = today.getDay()
      // getDay: 0=Sunday, 1=Monday, ..., 6=Saturday
      const daysUntilMonday = (8 - day) % 7 || 7
      const nextMonday = new Date(today)
      nextMonday.setDate(today.getDate() + daysUntilMonday)
      return nextMonday.toLocaleDateString('sv-SE').slice(0, 10)
    },
    async saveRefund(refund) {
      // Logic to save the refunds
      forEach(refund.paperGuaranteeAmount, (paper) => {
        paper.dateMenu = false
      })

      await adminapi
        .adminSaveRefunds(refund)
        .then(() => {
          log.debug('Refunds saved:', refund)
        })
        .catch((error) => {
          log.debug('Error - Saving refunds:', error)
          this.error = 'Misslyckades med att spara utbetalning.'
          throw error
        })
    },
    async send() {
      if (await this.valid()) {
        // Logic to send the refunds
        adminapi
          .adminSendRefunds(this.refundedGuarantees)
          .then((resp) => {
            log.debug('Refunds sent:', resp.data)

            // Get current year and ISO week number
            const now = new Date()

            const year = now.getFullYear()
            const week = this.getWeekNumber(now)

            let link = document.createElement('a')
            link.href =
              'data:application/octet-stream;base64,' + resp.data.aftonbladet
            link.target = '_blank'
            link.download = `aftonbladet_${year}_v${week}.csv`
            link.click()

            link = document.createElement('a')
            link.href =
              'data:application/octet-stream;base64,' + resp.data.expressen
            link.target = '_blank'
            link.download = `expressen_${year}_v${week}.csv`
            link.click()
          })
          .catch((error) => {
            log.debug('Error - Sending refunds:', error)
            this.error = 'Misslyckades med att hämta utbetalningsfiler.'
          })
      }
    },
    async getAllReciepts() {
      if (await this.valid()) {
        // Logic to send the refunds
        adminapi
          .adminGetReceipts(this.refundedGuarantees)
          .then((resp) => {
            const now = new Date()
            const year = now.getFullYear()
            const week = this.getWeekNumber(now)

            if (resp.data.aftonbladet !== null) {
              var link = document.createElement('a')
              link.href =
                'data:application/octet-stream;base64,' + resp.data.aftonbladet
              link.target = '_blank'
              link.download = `underlag_aftonbladet_${year}_v${week}.pdf`
              link.click()
            }
            if (resp.data.expressen !== null) {
              link = document.createElement('a')
              link.href =
                'data:application/octet-stream;base64,' + resp.data.expressen
              link.target = '_blank'
              link.download = `underlag_expressen_${year}_v${week}.pdf`
              link.click()
            }
          })
          .catch((error) => {
            log.debug('Error - Sending refunds:', error)
            this.error = 'Misslyckades med att hämta underlag.'
          })
      }
    },
    async getReciept(guarantee, key, validate) {
      
      if (validate){
       if(await this.valid(key) ) {
        // Logic to send the refunds
        adminapi
          .adminGetReceipt(guarantee)
          .then((resp) => {
            const customerNr = guarantee.customerNr || 'unknown'
            if (resp.data.aftonbladet !== null) {
              var link = document.createElement('a')
              link.href =
                'data:application/octet-stream;base64,' + resp.data.aftonbladet
              link.target = '_blank'
              link.download = `Underlag${customerNr}_aftonbladet.pdf`
              link.click()
            }

            if (resp.data.expressen !== null) {
              link = document.createElement('a')
              link.href =
                'data:application/octet-stream;base64,' + resp.data.expressen
              link.target = '_blank'
              link.download = `Underlag${customerNr}_expressen.pdf`
              link.click()
            }
          })
          .catch((error) => {
            log.debug('Error - Sending refunds:', error)
            this.error = 'Misslyckades med att hämta underlag.'
          })
      }}
      else{
        adminapi
          .adminGetReceipt(guarantee)
          .then((resp) => {
            const customerNr = guarantee.customerNr || 'unknown'
            if (resp.data.aftonbladet !== null) {
              var link = document.createElement('a')
              link.href =
                'data:application/octet-stream;base64,' + resp.data.aftonbladet
              link.target = '_blank'
              link.download = `Underlag${customerNr}_aftonbladet.pdf`
              link.click()
            }

            if (resp.data.expressen !== null) {
              link = document.createElement('a')
              link.href =
                'data:application/octet-stream;base64,' + resp.data.expressen
              link.target = '_blank'
              link.download = `Underlag${customerNr}_expressen.pdf`
              link.click()
            }
          })
          .catch((error) => {
            log.debug('Error - Sending refunds:', error)
            this.error = 'Misslyckades med att hämta underlag.'
          })
      }
    },
    completeQuestion() {
      this.dialogComplete = true
    },
    completedConfirm() {
      this.dialogComplete = false
      this.completed()
    },
    async completed() {
      if (await this.valid()) {
        // Continue with your logic to send the refunds
        adminapi
          .adminSetGuaranteeCompleted(this.refundedGuarantees)
          .then(() => {
            this.refundedGuarantees = []
          })
          .catch((error) => {
            log.debug('Error - Sending refunds:', error)
            this.error = 'Misslyckades med att klarmarkera garantibelopp.'
          })
      }
    },
    async valid(key) {
      
      if (key !== undefined) {
        const child = this.$refs.guaranteeCustomerInfoRefs[key]
        const childValid = await child.validate()
        if (!childValid) {
          if (this.$toast)
            this.$toast.error('Vänligen fyll i alla obligatoriska fält!')
          return false
        }
        return true
      }
      const parentValid = this.$refs.form.validate()


      // Ensure we have an array of child refs
      const children = Array.isArray(this.$refs.guaranteeCustomerInfoRefs)
        ? this.$refs.guaranteeCustomerInfoRefs
        : [this.$refs.guaranteeCustomerInfoRefs] // Fallback in case it's a single child

      const childResults = await Promise.all(
        children.map((child) => child.validate())
      )

      const allChildrenValid = childResults.every((valid) => valid)
      if (!parentValid || !allChildrenValid) {
        if (this.$toast)
          this.$toast.error('Vänligen fyll i alla obligatoriska fält!')
        return false
      }
      return true
    },
    getWeekNumber(d) {
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
      const dayNum = d.getUTCDay() || 7
      d.setUTCDate(d.getUTCDate() + 4 - dayNum)
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
      const weekNum = Math.ceil(((d - yearStart) / 86400000 + 1) / 7)
      return weekNum
    },
    async updateBankgiro(newBankgiro, customer) {
      try {
        if (
          newBankgiro === null ||
          newBankgiro === undefined ||
          newBankgiro === ''
        ) {
          newBankgiro = '-1'
        }
        // Call your backend API to up
        // date the bankgiro
        await adminapi.adminUpdateBankgiro({
          customerNr: customer.customerNo,
          bankgiro: newBankgiro,
        })
        if (this.$toast) this.$toast.success('Bankgiro uppdaterat!')
      } catch (error) {
        log.debug('Error - Updating bankgiro:', error)
        this.error = 'Misslyckades med att uppdatera bankgiro.'
      }
    },
    async updateBankaccount(newBankaccount, customer) {
      try {
        if (
          newBankaccount === null ||
          newBankaccount === undefined ||
          newBankaccount === ''
        ) {
          newBankaccount = '-1'
        }
        // Call your backend API to update the bankaccount
        await adminapi.adminUpdateBankaccount({
          customerNr: customer.customerNo,
          bankaccount: newBankaccount,
        })
        if (this.$toast) this.$toast.success('Bankaccount uppdaterat!')
      } catch (error) {
        log.debug('Error - Updating bankaccount:', error)
        this.error = 'Misslyckades med att uppdatera bankaccount.'
      }
    },
    async updateOrgnumber(neworgnummer, customer) {
      try {
        // Call your backend API to update the bankgiro
        await adminapi.adminUpdateOrgnumber({
          customerNr: customer.customerNo,
          orgnumber: neworgnummer,
        })
        if (this.$toast) this.$toast.success('Orgnummer uppdaterat!')
      } catch (error) {
        log.debug('Error - Updating bankgiro:', error)
        this.error = 'Misslyckades med att uppdatera orgnummer.'
      }
    },
    openInvoiceDialog(paper, guarantee) {
      this.selectedPaper = paper

      this.invoiceData = {
        invoiceNumber: '',
        amount: '',
        ocr: '',
        ledger: paper.ledger,
        guarantee: guarantee,
      }
      
      this.dialogInvoice = true
    },
    closeInvoice() {
      this.dialogInvoice = false
      this.$refs.invoiceForm.reset()
      this.selectedPaper = null
      this.invoiceData = {}
    },
    async submitInvoice() {
      if (!this.$refs.invoiceForm.validate()) return

      try {
          let refund = this.refundedGuarantees.find(
        (refund) => refund.customerNr == this.invoiceData.guarantee.customerNr
      )
      if (refund !== undefined) {
        refund.invoices.push({amount: this.invoiceData.amount,
          ledger: this.invoiceData.ledger,
          invoiceNumber: this.invoiceData.invoiceNumber,
          ocr: this.invoiceData.ocr,
          usedDateTime: new Date().toISOString(),
          customerNr : this.invoiceData.guarantee.customerNr,
          status:0
        })
      } else {

        refund = {
          guaranteeCustomer: clone(this.invoiceData.guarantee.guaranteeCustomer),
          customerNr: this.invoiceData.guarantee.customerNr,
          paperGuaranteeAmount: [],
          invoices: [],
        }
        refund.guaranteeCustomer.bankgiro = ''
        refund.guaranteeCustomer.bankaccount = ''
        refund.invoices.push({
          amount: this.invoiceData.amount,
          ledger: this.invoiceData.ledger,
          invoiceNumber: this.invoiceData.invoiceNumber,
          ocr: this.invoiceData.ocr,
          usedDateTime: new Date().toISOString(),
          customerNr :refund.customerNr,
          status:0
        })
      }
       
        await adminapi.adminAddGuanranteeInvoice(refund).then(() => {
          this.guarantees = this.guarantees.map((guarantee) => {
            if (guarantee.customerNr === this.invoiceData.guarantee.customerNr) {
              guarantee.invoices.push({
                amount: this.invoiceData.amount,
                ledger: this.invoiceData.ledger,
                invoiceNumber: this.invoiceData.invoiceNumber,
                ocr: this.invoiceData.ocr,
                usedDateTime: new Date().toISOString(),
                status:1,
                customer: this.invoiceData.guarantee.customerNr
              })
              guarantee.paperGuaranteeAmount = guarantee.paperGuaranteeAmount.map((paper) => {
                if (paper.ledger === this.invoiceData.ledger) {
                  paper.amount -= this.invoiceData.amount
                  paper.status=0
                }
                return paper
              })
            }
            return guarantee
          })
          
          let g = this.guarantees.find((guarantee) => {
            if (guarantee.customerNr === this.invoiceData.guarantee.customerNr) {
              return guarantee
            }
          })
          console.log('Updated Guarantee:', g)          
          adminapi.adminUpdateRefunds(g ).then(() => {
            log.debug('Refunds updated after invoice addition:', g)
            refund  =g
          })
          
        }).then(() => {
          log.debug('Invoice added:', this.invoiceData)
        
          if (!this.refundedGuarantees.includes(refund)) {
            this.refundedGuarantees.unshift(refund)
          }
        
          if (this.$toast) this.$toast.success('Faktura sparad!')
          this.closeInvoice()
          // Optionally refresh data
          this.fetchGuarantees(this.searchQuery)
          this.loadData()
        })
      } catch (error) {
        log.debug('Error - Adding invoice:', error)
        this.error = 'Misslyckades med att spara faktura.'
      }
    },
  },
}
</script>

<style scoped>
  .elevation-3 {
  box-shadow: 0px 3px 3px 1px rgba(255, 0, 0, 0.2), /* Red tint */
              0px 3px 5px 0px rgba(255, 0, 0, 0.1),
              0px 1px 11px 1px rgba(255, 0, 0, 0.12) !important;
}
.guarantees {
  padding: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  background-color: #f4f4f4;
  text-align: left;
}
</style>
